import { DeliveryConfiguration } from '../../../../@types/model/deliveryConfiguration';
import { DeliveryRequestItem } from '../../../../@types/model/deliveryRequest';
import generateSlotsOccupiedGrouped from './generateSlotsOccupiedGrouped';

const calcTotalSlotsOccupiedTruck = (
  deliveryRequestItems: DeliveryRequestItem[],
  deliveryConfiguration: DeliveryConfiguration,
  newDeliveryRequestItem: DeliveryRequestItem | null
): number => {
  const products = generateSlotsOccupiedGrouped(
    deliveryRequestItems,
    deliveryConfiguration,
    newDeliveryRequestItem
  );
  let totalSlots = 0;
  products.forEach((p) => {
    totalSlots += Math.ceil(p.quantity / deliveryConfiguration.configuration.slot_amount);
  });

  return totalSlots;
};

export default calcTotalSlotsOccupiedTruck;
